import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, ActivatedRoute } from '@angular/router';
import { Observable, of, firstValueFrom } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { LocalService } from './local.service';
import { PlatformUserService } from './platform-user.service';
import { map, switchMap, catchError, tap } from 'rxjs/operators';
import { Auth, authState } from '@angular/fire/auth';
import { AuthGuardService } from './auth-guard.service';

@Injectable({
    providedIn: 'root'
})
export class OwnerDashboardGuard implements CanActivate {
    private currentUserProfile: any = null;

    constructor(
        private authService: AuthenticationService,
        private router: Router,
        private localService: LocalService,
        private platformUserService: PlatformUserService,
        private route:ActivatedRoute,
        private authGuardService: AuthGuardService,
        public af: Auth
    ) {
        // Invalidate cache on logout
        authState(this.af).subscribe(user => {
            if (!user) {
                this.currentUserProfile = null;
            }
        });
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        // Check Cache First
        if (this.currentUserProfile) {
            return this.checkOwnersRole(this.currentUserProfile, state);
        }

        const userKey = this.localService.getJsonValue('UserKey');

        if (userKey) {
            return this.platformUserService.fetchPlatformUser(userKey).pipe(
                tap(user => {
                    if (user) this.currentUserProfile = user;
                }),
                map(user => {
                    return this.checkOwnersRole(user, state);
                }),
                catchError(() => {
                    return of(this.loginUrl(state.url));
                })
            );
        } else {
            return this.authGuardService.getUser().then(firebaseUser => {
                if (firebaseUser) {
                    return firstValueFrom(this.platformUserService.fetchPlatformUserByUid(firebaseUser.uid).pipe(
                        tap(user => {
                            if (user) this.currentUserProfile = user;
                        }),
                        map(user => {
                            return this.checkOwnersRole(user, state);
                        }),
                        catchError(() => {
                            return of(this.loginUrl(state.url));
                        })
                    ));
                } else {
                    return this.loginUrl(state.url);
                }
            });
        }
    }

    private loginUrl(returnUrl: string): UrlTree {
        return this.router.createUrlTree(['/login'], { queryParams: { returnUrl } });
    }

    private checkOwnersRole(user: any,state: RouterStateSnapshot): boolean | UrlTree {

        // normal user can to override emails being sent with admin /// to redirect to the home and there it can be handled and routed properly
        if (user && user.role === 'Owner' || state.url.includes("owners/action-plan")) {
            return true;
        } else {
            return this.router.createUrlTree(['/home']);
        }
    }
}
